export default __webpack_public_path__ + "static/media/hatchway.8620fcdf.jpeg";